import { AppSharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmartActionsComponent } from './smart-actions.component';



@NgModule({
  declarations: [SmartActionsComponent],
  imports: [
    CommonModule,
    AppSharedModule
  ],
  exports: [SmartActionsComponent],

})
export class SmartActionsModule { }
